import withIntl from "../../utils/withIntl";
import React, { useState } from "react";
import TextFieldForms from "../Forms/TextFieldForms";
import InputAdornment from "@material-ui/core/InputAdornment";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import ChangeAmountButtons from "./ChangeAmountButtons";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { Checkbox, FormControlLabel, Tooltip } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles({
  textFieldContainer: {
    display: "flex",
    flexDirection: "column",
    margin: 10,
  },
  label: { width: "100%" },
  input: { width: "100%" },
});

function CategoriesSetting(props) {
  const classes = useStyles();
  const [newCategorieKey, setNewCategorieKey] = React.useState("");
  const [noLimit, setNoLimit] = useState(props.setting == null);

  const setting = props.setting ?? { max_weight_per_cover: 5 };
  return (
    <div className={classes.textFieldContainer}>
      <div className={classes.label}>
        <Typography style={{ fontWeight: 600 }}>
          {props.title}
          {props.intl.formatMessage({ id: "categories" })}
        </Typography>
        <Typography variant="caption" style={{ color: "gray" }}>
          {props.helperTextLabel ?? ""}
        </Typography>
      </div>
      <div className={classes.input}>
        <FormControlLabel
          label={"No limit"}
          control={
            <Checkbox
              checked={noLimit}
              onChange={(e) => {
                setNoLimit(e.target.checked);
                if (e.target.checked) {
                  props.onChangeFields(null);
                } else {
                  props.onChangeFields(setting);
                }
              }}
            />
          }
        />
        {!noLimit && (
          <>
            <TextFieldForms
              type={"number"}
              label={"Max weight per round per cover"}
              value={setting.max_weight_per_cover}
              onChange={(event) => {
                let newValue = { ...setting, max_weight_per_cover: parseInt(event.target.value) };
                props.onChangeFields(newValue);
              }}
            />
            <TextFieldForms
              value={newCategorieKey}
              onChange={(e) => {
                setNewCategorieKey(e.target.value);
              }}
              label={props.intl.formatMessage({ id: "categories" })}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <AddCircleIcon
                      onClick={() => {
                        let newCategorie = { [newCategorieKey]: { max_weight_per_cover: 2 } };
                        props.updateCategories(newCategorie);
                        setNewCategorieKey("");
                      }}
                      color={"primary"}
                    />
                  </InputAdornment>
                ),
              }}
            />
            {Object.keys(setting).map((key) => {
              if (key !== "max_weight_per_cover")
                return (
                  <>
                    <Grid container spacing={3}>
                      <Grid item xs={6}>
                        <Typography>{key}</Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Tooltip title={"remove"}>
                          <IconButton
                            color={"primary"}
                            onClick={() => {
                              let categorie = { [key]: setting[key] };
                              props.updateCategories(categorie, "removed");
                            }}
                          >
                            <CloseIcon />
                          </IconButton>
                        </Tooltip>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography>Max weight per cover</Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <ChangeAmountButtons
                          value={setting[key].max_weight_per_cover ?? ""}
                          setValue={(value) => {
                            let newCategorie = { [key]: { ...setting[key], max_weight_per_cover: parseInt(value) } };
                            props.updateCategories(newCategorie);
                          }}
                          onDelete={() => {
                            let categorie = { [key]: { ...setting[key] } };
                            delete categorie[key].max_weight_per_cover;
                            props.updateCategories(categorie);
                          }}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <Typography>Total max weight per cover</Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <ChangeAmountButtons
                          value={setting[key].total_max_weight_per_cover ?? ""}
                          setValue={(value) => {
                            let newCategorie = {
                              [key]: { ...setting[key], total_max_weight_per_cover: parseInt(value) },
                            };
                            props.updateCategories(newCategorie);
                          }}
                          onDelete={() => {
                            let categorie = { [key]: { ...setting[key] } };
                            delete categorie[key].total_max_weight_per_cover;
                            props.updateCategories(categorie);
                          }}
                        />
                      </Grid>
                    </Grid>
                  </>
                );
            })}
          </>
        )}
        <Divider style={{ marginTop: "8px", marginBottom: "8px" }} />
      </div>
    </div>
  );
}

export default withIntl(CategoriesSetting);
